import { render } from "./DevicesSingleScreen.vue?vue&type=template&id=c966c15c"
import script from "./DevicesSingleScreen.vue?vue&type=script&lang=js"
export * from "./DevicesSingleScreen.vue?vue&type=script&lang=js"

import "./DevicesSingleScreen.vue?vue&type=style&index=0&id=c966c15c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__